import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CSVReader from 'react-csv-reader';
import { Typography } from '@material-ui/core';
import APIService from '../services/APIService';
import AppContext from '../AppContext';
import moment from 'moment';
import Spinner from './Spinner';
import { withTranslation } from 'react-i18next';

class MenuImporter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            errors: [],
            ready: false,
            loading: false
        };

        this.handleData = this.handleData.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onError = this.onError.bind(this);
        this.addItems = this.addItems.bind(this);
    }

    handleData(items) {
        let ready = true;
        let errors = [];
        let count = 0;

        const keys = ['date_from', 'date_to', 'name', 'type', 'weight', 'price'];
        let mappedData = items.reduce((acc, item) => {
            let o = {};
            keys.forEach((key, index) => o[key] = item[index] || null);

            if (!o.date_from || !o.date_to) return acc;

            o.date_from = o.date_from.replace(/[\/\.]/g, '-');
            o.date_to = o.date_to.replace(/[\/\.]/g, '-');

            o.date_from = moment(o.date_from, 'DD-MM-YYYY').format('YYYY-MM-DD');
            o.date_to = moment(o.date_to, 'DD-MM-YYYY').format('YYYY-MM-DD');

            if (!o.date_from || !o.date_to || !o.type)
                return acc;

            let menuType = o.weight ? 1 : 2;
            if (this.types[menuType][o.type]) {
                o.food_type_id = this.types[menuType][o.type];

                acc[o.date_from] = acc[o.date_from] || {};
                acc[o.date_from][o.date_to] = acc[o.date_from][o.date_to] || {};
                acc[o.date_from][o.date_to][menuType] = acc[o.date_from][o.date_to][menuType] || [];

                // Replace weight colons with dots
                if (o.weight) {
                    o.weight = o.weight.replace(',', '.');
                }

                // Replace price colons with dots
                if (o.price) {
                    o.price = o.price.replace(',', '.');
                }

                acc[o.date_from][o.date_to][menuType].push(o);

                count++;
            } else {
                ready = false;
                errors.push(this.props.t('Ruokalajia ei löytynyt', { type: o.type }))
            }

            return acc;
        }, {});

        this.setState({ items: mappedData, count, ready, errors });
    }

    onError() {
        console.log(arguments);
    }

    async addItemsToMenu(restaurantId, menuId, items) {
        items.forEach((item, index) => {
            item.order = index + 1;
        });

        return await APIService.storeMenuItems(restaurantId, menuId, items);
    }

    async addItems() {
        this.setState({ loading: true });

        const { items } = this.state;
        let promises = [];
        let createdMenus = [];

        let restaurantIds = Array.isArray(this.props.restaurantId) ? this.props.restaurantId : [this.props.restaurantId];
        let restaurantId, date_to, date_from, type;

        let dateFroms = Object.keys(items);

        for (let i = 0; i < restaurantIds.length; i++) {
            restaurantId = restaurantIds[i];

            for (let j = 0; j < dateFroms.length; j++) {
                date_from = dateFroms[j];
                let dateTos = Object.keys(items[date_from]);

                for (let k = 0; k < dateTos.length; k++) {
                    date_to = dateTos[k];
                    let types = Object.keys(items[date_from][date_to]);

                    for (let v = 0; v < types.length; v++) {
                        type = types[v];

                        let menu = { date_from, date_to, type };
                        let menuItems = items[date_from][date_to][type];

                        try {
                            menu = await APIService.storeMenu(restaurantId, menu);

                            if (menu && !menu.existed) {
                                createdMenus.push(menu);
                            }

                            await this.addItemsToMenu(restaurantId, menu.id, menuItems);
                        } catch (e) {
                            console.error(e);
                            return AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e);
                        }
                    }
                }
            }
        }
        // restaurantIds.forEach(restaurantId => {
        //     Object.keys(items).forEach((date_from) => {
        //         Object.keys(items[date_from]).forEach((date_to) => {
        //             Object.keys(items[date_from][date_to]).forEach((type) => {
        //                 let menu = {date_from, date_to, type};
        //                 let menuItems = items[date_from][date_to][type];

        //                 await APIService.storeMenu(restaurantId, menu)
        //                     .then((menu) => {
        //                         if (menu) {
        //                             if (!menu.existed)
        //                                 createdMenus.push(menu);

        //                             return this.addItemsToMenu(restaurantId, menu.id, menuItems);
        //                         }
        //                     }).then().catch((e) => {
        //                         AppContext.toast('Tapahtui odottamaton virhe, ' + e);
        //                     });
        //             });
        //         });
        //     });
        // });


        this.setState({ loading: false });

        return this.props.onReceiveMenus(createdMenus);
    }

    handleClose() {
        this.setState({ items: [], ready: false });
        this.props.onClose();
    }

    componentDidMount() {
        APIService.getFoodTypes()
            .then((types) => {
                this.types = types.reduce((acc, type) => {
                    if (!acc[type.type]) acc[type.type] = [];

                    acc[type.type][type.name] = type.id;
                    return acc;
                }, {});
            });
    }

    render() {
        if (this.state.loading) {
            return <Dialog
                open={this.props.open}
                onClose={() => this.handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <Spinner text={this.props.t('Talletetaan ruokalistoja')} />
                </DialogContent>
            </Dialog>;
        }

        return (
            <Dialog
                open={this.props.open}
                onClose={() => this.handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{this.props.t('Tuo tiedostosta')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {this.props.t('Valitse tiedosto josta haluat tuoda ruokalistan', { extension: '(.csv)' })}
                    </DialogContentText>

                    <CSVReader
                        onFileLoaded={this.handleData}
                        onError={this.onError}
                    />

                    <Typography variant="subheading">{this.state.items.length > 0 ? this.props.t('Löytyi ruokalajia', { count: this.state.items.length }) : ''}</Typography>

                    {this.state.errors.map((error, index) =>
                        <Typography key={index} variant="subheading" color="error">{error}</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleClose()} color="primary">
                        {this.props.t('Peruuta')}
                    </Button>
                    <Button onClick={() => this.addItems().then(this.handleClose)} color="primary" autoFocus disabled={!this.state.ready}>
                        {this.props.t('Tuo')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

MenuImporter.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withTranslation()(MenuImporter);



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuImporter.js